import React from 'react';
import PropTypes from 'prop-types';
import uniqBy from 'lodash.uniqby';
import { useSelector } from 'react-redux';
import { RxRulerHorizontal } from "@react-icons/all-files/rx/RxRulerHorizontal";
import { useDispatch } from 'react-redux';
import { Button } from 'day8-ui';
import {
  getSelectedFilters, isFilterSelected, onFilterSelect
} from '../../../../helpers/filter';
import { FILTERS } from '../../../../constants';

const BoatSize = props => {
  const dispatch = useDispatch();
  const yachts = useSelector(state => state.yachts.items);
  const boatSizeOptions = uniqBy(yachts, 'boat.size')
    .map(yacht => yacht.boat.size)
    .sort((a, b) => a - b);
  const selectedFilterText = getSelectedFilters(props.location)[FILTERS.BOAT_SIZE].map(item => item).join('ft, ');
  return props.mobile ? (
    <div className={props.className}>
      <h3 className='dui-font-body !dui-font-normal dui-tracking-normal'>Boat size</h3>
      <div className='dui-flex dui-flex-wrap dui-gap-4 dui-mt-4'>
        {boatSizeOptions.map(size => (
          <Button key={size} buttonType={isFilterSelected(props.location, FILTERS.BOAT_SIZE, size) ? "FILTER_ACTIVE" : "FILTER"} onClick={() => onFilterSelect(props.location, dispatch, props.filterAction, FILTERS.BOAT_SIZE, size)}>{size} ft</Button>
        ))}
      </div>
    </div>
  ) : <Button buttonType="LINK" onClick={props.filterModalToggle} leftIcon={<RxRulerHorizontal />}>{selectedFilterText || 'Boat Size'}</Button>;
};
BoatSize.propTypes = {
  location: PropTypes.object.isRequired,
  filterAction: PropTypes.func.isRequired,
  setPage: PropTypes.func,
  mobile: PropTypes.bool,
  renderFilterMenuButton: PropTypes.bool,
  filterModalToggle: PropTypes.bool,
  className: PropTypes.string
};
export default BoatSize;
